module.exports = __webpack_public_path__ + "static/img/2.9ea5ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fuwu/2.png
// module id = IZkR
// module chunks = 1